<template>
    <div class="tools-tab tools-tab-shift">
        <ul class="list list-shifts">
            <li v-for="shift in activeShifts" :class="[hasShift(shift) ? 'is-active' : '']" @click="select(shift)">
                <em>{{ shift.identifier }}</em>
                <span>{{ shift.name }}</span>
                <icon name="delete" v-if="hasShift(shift)" />
                <icon name="add" v-else />
            </li>
        </ul>
        <div class="empty" v-if="! shifts.length">
            {{ $t('page.settings.shifts.empty') }}
        </div>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Shift',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        activeShifts()
        {
            // TODO: might need to add legacy shift as well, if previously assigned!
            return _.filter(this.shared.shifts, {trashed: false});
        },

        shifts()
        {
            return _.sortBy(this.shared.shifts, ['name']);
        },
    },

    methods:
    {
        hasShift(shift)
        {
            return shift.id == this.item.shift;
        },

        select(shift)
        {
            if (this.hasShift(shift))
            {
                this.remove(shift);
            }
            else
            {
                this.add(shift);
            }
        },

        updateUserStats(item)
        {
            events.$emit('recalculate', item.date);

            if ( ! item.assigned) return;

            shared.getUser(item.user).stats = item.stats;
        },

        add(shift, confirmed)
        {
            if (shared.hasApplications(this.item)) return;

            this.$http.put(
            '/api/items/' + this.item.id + '/shift',
            {
                shift: shift.id,
                confirmed: confirmed,
            })
            .then(response =>
            {
                let key = _.findIndex(this.shared.items, {id: this.item.id});

                // replace item
                this.$set(this.shared.items, key, response.data);

                this.updateUserStats(response.data);

                this.$tools.close();
            })
            .catch(error =>
            {
                let user = shared.getUser(this.item.user);

                switch (error.response.data.error)
                {
                    case 'ERR_CONFIRMED':
                        this.$modal.show(this.$t('page.roster.shift.error.headline'), this.$t('page.roster.shift.error.ERR_CONFIRMED'));
                    break;

                    case 'ERR_OVERLAP':
                        this.$modal.show(this.$t('page.roster.shift.error.headline'), user.name + ' ' + this.$t('page.roster.shift.error.ERR_OVERLAP'));
                    break;

                    case 'ERR_OVERLAP_REST':
                        // overlap in resting period of another item of user
                        this.$confirm.show(this.$t('page.roster.shift.error.headline'), this.$t('confirm.resting.conflict', {name: user.name}),
                        {
                            confirm: () =>
                            {
                                this.add(shift, 'OVERRULE_REST');
                            },
                        });
                    break;

                    case 'ERR_UNAVAILABLE_LIMITED':
                        // user is limited available, schedule anyway?
                        this.$confirm.show(this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'),
                        {
                            confirm: () =>
                            {
                                this.add(shift, true);
                            }
                        });
                    break;
                }
            });
        },

        remove(shift, confirmed)
        {
            if (shared.hasApplications(this.item)) return;

            this.$http.delete('/api/items/' + this.item.id + '/shift', {
                params: {
                    confirmed: confirmed
                }
            })
            .then(response =>
            {
                this.item.shift = null;
                this.item.times = null;

                this.updateUserStats(this.item);

                this.$tools.close();
            })
            .catch(error =>
            {
                let user = shared.getUser(this.item.user);

                switch (error.response.data.error)
                {
                    case 'ERR_SICK':
                        // cannot remove times, because assigned user has been marked sick
                        this.$modal.show(this.$t('page.roster.time.delete.error.headline'), this.$t('page.roster.sick.ERR_TIME.text'));
                    break;

                    case 'ERR_OVERLAP':
                        // cannot remove time, because full day item would overlap with other existing items
                        this.$modal.show(this.$t('page.roster.time.delete.error.headline'), user.name + ' ' + this.$t('page.roster.time.error.ERR_OVERLAP_REMOVAL'));
                    break;

                    case 'ERR_OVERLAP_REST':
                        // overlap in resting period of another item of user
                        this.$confirm.show(this.$t('page.roster.time.delete.error.headline'), this.$t('confirm.resting.conflict', {name: user.name}),
                        {
                            confirm: () =>
                            {
                                this.remove(shift, 'OVERRULE_REST');
                            },
                        });
                    break;

                    case 'ERR_CONFIRMED':
                        // cannot remove item, because hours have been approved
                        this.$modal.show(this.$t('page.roster.time.delete.error.headline'), this.$t('page.roster.shift.error.ERR_CONFIRMED'));
                    break;

                    case 'ERR_UNAVAILABLE_LIMITED':
                        // user is limited available, remove anyway?
                        this.$confirm.show(this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'),
                        {
                            confirm: () =>
                            {
                                this.remove(shift, true);
                            }
                        });
                    break;
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// Shift.vue?554d1f1c